import { useEffect, useState } from "react";
import { api, fmtMoney } from "@/lib/api";
import { Sparkles, ArrowRight } from "lucide-react";

/** Inline best-card nudge. Only renders when the API detects a materially
 *  better card in the user's wallet (savings > ₹100/year). Silent otherwise. */
export default function BestCardHint({ subscriptionId }) {
    const [r, setR] = useState(null);

    useEffect(() => {
        let cancelled = false;
        api.get(`/subscriptions/${subscriptionId}/best-card`)
            .then(({ data }) => { if (!cancelled) setR(data); })
            .catch(() => { /* silent */ });
        return () => { cancelled = true; };
    }, [subscriptionId]);

    if (!r || !r.has_better || !r.alternates?.length) return null;
    const better = r.alternates[0];

    return (
        <div className="mt-2 flex items-center gap-2 px-3 py-2 rounded-md bg-violet-50 border border-violet-200"
             data-testid={`best-card-hint-${subscriptionId}`}>
            <Sparkles size={12} className="text-violet-700 shrink-0" />
            <div className="flex-1 min-w-0 text-[12px] text-violet-900">
                Save <span className="font-semibold tabular-nums">{fmtMoney(r.potential_annual_savings_inr, "INR")}</span>/year
                if you charge this to <span className="font-medium">{better.card_label}</span>
                {better.reasons?.[0] && (
                    <span className="text-violet-700"> &mdash; {better.reasons[0]}</span>
                )}
            </div>
            <ArrowRight size={11} className="text-violet-500 shrink-0" />
        </div>
    );
}
